import { createReducer, on } from '@ngrx/store';

import {
  deleteAppSettings,
  deleteEnvironments,
  deleteEnvironmentsFailure,
  deleteTechnologyStack,
  getAppSettings,
  getEnvironments,
  getTechnologyStack,
  saveAppSettings,
  saveEnvironments,
  saveTechnologyStack,
  sentUpdateEnvironments,
  setAppMetaInfo,
  setAppSettings,
  setEnvironments,
  setMemberApps,
  setSharedDbs,
  setTechnologyStack,
  updateAppSettings,
  updateEnvironments,
  updateTechnologyStack,
  sentEnvironments,
  saveEnvironmentsSuccess,
  saveEnvironmentsFailure
} from '../actions/technologystack.actions';

export interface TechnologyStackState {
  data: any;
  saveEnvironmentsSuccess?: boolean;
  saveEnvironmentsFailure?: any;
  deleteEnvironmentsFailure?: { envId: string; error: any } | null;
}

export const initialState: TechnologyStackState = {
  data: {},
  saveEnvironmentsSuccess: false,
  saveEnvironmentsFailure: null,
  deleteEnvironmentsFailure: null
};

export const technologystackReducer = createReducer(
  initialState,

  on(getTechnologyStack, (state, { apiConstants }) => ({
    ...state,
    ...apiConstants
  })),
  on(setTechnologyStack, (state, { technologyStackData }) => ({
    ...state,
    ...{ technologyStackData }
  })),

  on(setAppMetaInfo, (state, { metaInfoData }) => ({
    ...state,
    ...{ metaInfoData }
  })),

  on(setMemberApps, (state, { memberApps }) => ({
    ...state,
    ...{ memberApps }
  })),

  on(saveTechnologyStack, (state, { technologyStackData }) => ({
    ...state,
    ...technologyStackData
  })),
  on(updateTechnologyStack, (state, { technologyStackData }) => {
    return {
      ...state,
      ...technologyStackData
    };
  }),

  on(setSharedDbs, (state, { sharedDbs }) => {
    return {
      ...state,
      ...{ sharedDbs }
    };
  }),
  on(deleteTechnologyStack, (state, { technologyStackId }) => {
    return {
      ...state,
      technologyStackId
    };
  }),

  on(getAppSettings, (state, { apiConstants }) => ({
    ...state,
    ...apiConstants
  })),
  on(setAppSettings, (state, { settingsData }) => ({
    ...state,
    ...{ settingsData }
  })),

  on(saveAppSettings, (state, { settingsData }) => ({
    ...state,
    settingsData
  })),
  on(updateAppSettings, (state, { settingsData }) => {
    return {
      ...state,
      settingsData
    };
  }),
  on(deleteAppSettings, (state, { settingsId }) => {
    return {
      ...state,
      settingsId
    };
  }),
  on(getEnvironments, (state, { envapiConstants }) => ({
    ...state,
    ...{ envapiConstants }
  })),
  on(setEnvironments, (state, { environmentDataList }) => ({
    ...state,
    ...{ environmentDataList }
  })),
  on(saveEnvironments, (state, { environmentData }) => ({
    ...state,
    ...environmentData
  })),
  on(updateEnvironments, (state, { updateEnvironmentData }) => {
    return {
      ...state,
      ...updateEnvironmentData
    };
  }),
  on(deleteEnvironments, (state, { envId }) => {
    const envList = (state as any).environmentDataList;
    const updatedEnvList = Array.isArray(envList)
      ? envList.filter((env: any) => env.sid !== envId)
      : envList;
    return {
      ...state,
      envId,
      environmentDataList: updatedEnvList,
      deleteEnvironmentsFailure: null
    };
  }),
  on(deleteEnvironmentsFailure, (state, { envId, error }) => ({
    ...state,
    deleteEnvironmentsFailure: { envId, error }
  })),
  on(saveEnvironmentsSuccess, (state) => ({
    ...state,
    ...{ saveEnvironmentsSuccess: true },
    saveEnvironmentsFailure: null
  })),
  on(saveEnvironmentsFailure, (state, { error }) => ({
    ...state,
    ...{ saveEnvironmentsSuccess: false },
    saveEnvironmentsFailure: error
  })),
  on(sentEnvironments, (state) => ({
    ...state,
    ...{ saveEnvironmentsSuccess: false },
    saveEnvironmentsFailure: null
  }))
);
